/**
 * 章节+草稿数据服务（Axios 版本）
 * 替换原有的 WebSocket 实现
 */
import { ref } from 'vue';
import { getChapterIntroduce, getOneNovel, getDraftIntroduce, createDraft, deleteDraft, deleteChapter } from './api';

export const chapterAndDraftWebSocket = (novel_id) => {
    const connected = ref(true); // Axios 总是"连接"状态
    const draft_introduce = ref([]);
    const chapter_introduce = ref([]);
    const novels = ref({});
    const loading = ref(false);
    const error = ref(null);
    const errorItNovel = ref(null);

    // 请求章节列表、小说详情和草稿列表
    const fetchNovelsChapter = async () => {
        loading.value = true;
        error.value = null;
        errorItNovel.value = null;

        try {
            // 并行请求章节列表、小说详情和草稿列表
            const [chaptersResult, novelResult, draftsResult] = await Promise.all([
                getChapterIntroduce(novel_id),
                getOneNovel(novel_id),
                getDraftIntroduce(novel_id)
            ]);

            // Result 结构：{ code: 0, msg: "success", data: [...] }
            if (chaptersResult.code === 0) {
                chapter_introduce.value = chaptersResult.data;
                console.log('获取章节信息成功');
            } else {
                error.value = chaptersResult.msg || '获取章节失败';
            }

            if (novelResult.code === 0) {
                novels.value = novelResult.data;
                console.log('获取小说信息成功');
            } else {
                errorItNovel.value = novelResult.msg || '获取小说信息失败';
            }

            if (draftsResult.code === 0) {
                draft_introduce.value = draftsResult.data;
                console.log('获取草稿信息成功');
            } else {
                error.value = draftsResult.msg || '获取草稿失败';
            }
        } catch (err) {
            console.error('请求数据失败:', err);
            error.value = err.message || '请求数据失败';
            errorItNovel.value = err.message || '请求数据失败';
        } finally {
            loading.value = false;
        }
    };

    // 创建新草稿
    const CreateDraft = async () => {
        loading.value = true;
        error.value = null;

        try {
            const result = await createDraft(novel_id);
            if (result.code === 0) {
                console.log('创建草稿成功');
                // 创建成功后重新获取草稿列表
                const draftsResult = await getDraftIntroduce(novel_id);
                if (draftsResult.code === 0) {
                    draft_introduce.value = draftsResult.data;
                }
            } else {
                error.value = result.msg || '创建草稿失败';
            }
        } catch (err) {
            console.error('创建草稿失败:', err);
            error.value = err.message || '创建草稿失败';
        } finally {
            loading.value = false;
        }
    };

    // 删除草稿
    const DeleteThisDraft = async (dId, dNovelId) => {
        loading.value = true;
        error.value = null;

        try {
            const result = await deleteDraft(dNovelId, dId);
            if (result.code === 0) {
                console.log('删除草稿成功');
                // 删除成功后重新获取草稿列表
                const draftsResult = await getDraftIntroduce(novel_id);
                if (draftsResult.code === 0) {
                    draft_introduce.value = draftsResult.data;
                }
            } else {
                error.value = result.msg || '删除草稿失败';
            }
        } catch (err) {
            console.error('删除草稿失败:', err);
            error.value = err.message || '删除草稿失败';
        } finally {
            loading.value = false;
        }
    };

    // 删除章节
    const DeleteThisChapter = async (cId, cNovelId) => {
        loading.value = true;
        error.value = null;

        try {
            const result = await deleteChapter(cNovelId, cId);
            if (result.code === 0) {
                console.log('删除章节成功');
                // 删除成功后重新获取章节列表
                const chaptersResult = await getChapterIntroduce(novel_id);
                if (chaptersResult.code === 0) {
                    chapter_introduce.value = chaptersResult.data;
                }
            } else {
                error.value = result.msg || '删除章节失败';
            }
        } catch (err) {
            console.error('删除章节失败:', err);
            error.value = err.message || '删除章节失败';
        } finally {
            loading.value = false;
        }
    };

    return {
        connected,
        draft_introduce,
        chapter_introduce,
        novels,
        loading,
        error,
        errorItNovel,
        fetchNovelsChapter,
        CreateDraft,
        DeleteThisDraft,
        DeleteThisChapter
    };
};
